import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";

@CwtModel({ name: 'brand' })
@CwtCrudContract({ path: 'brand', searchMapper: (search) => ({ name: { regexp: search } })})
export class Brand extends CwtApiEntity {
    @CwtProp() name: string;
}